// extracted by mini-css-extract-plugin
module.exports = {"fieldItem":"FieldItem_fieldItem__2LVZx","label":"FieldItem_label__fJsy2","value":"FieldItem_value__18Mrt"};